<script setup>
import { onMounted, onUnmounted, watch } from "vue";
import { useRoute } from "vue-router";
import SessionLockOverlay from "@/components/auth/SessionLockOverlay.vue";

const route = useRoute();

function updateBodyClass() {
  document.body.classList.toggle(
    "bg-linear-gradiant",
    route.path.includes("/lock-screen")
  );
}

onMounted(() => updateBodyClass());

onUnmounted(() => {
  document.body.classList.remove("bg-linear-gradiant");
});

watch(
  () => route.path,
  () => updateBodyClass()
);
</script>

<template>
  <SessionLockOverlay mode="page" />
</template>
